<template>
  <el-dialog
    title="选择地点"
    :visible.sync="visible"
    width="800px"
    :show-close="false"
    :close-on-click-modal="false"
    @before-close="handleClose"
  >
    <div class="map-container">
      <div class="map-search">
        <div class="el-input-style input-small el-input--prefix">
          <span class="el-input__prefix">
            <i class="el-icon-search"></i>
          </span>
          <input
            type="text"
            v-model="searchText"
            class="search"
            placeholder="请输入地点"
            @input="searchHandler"
            @keydown.up="handleKeyUp"
            @keydown.down="handleKeyDown"
            @keydown.enter="handleKeyEnter"
          />
        </div>
        <ul v-if="kwData.length != 0" class="el-autocomplete-suggestion__list">
          <li
            v-for="(kw, i) in kwData"
            :key="i"
            @click="clickLiHandler(kw)"
            :class="{ highlighted: i === highlightedIndex }"
          >
            {{ kw.title }}
            <span class="address" v-if="kw.address">{{ kw.address }}</span>
          </li>
        </ul>
      </div>

      <div id="map-container" style="width: 100%; height: 500px"></div>

      <div v-if="selectedAddress" class="selected-info">
        <p>选中地址: {{ selectedAddress }}</p>
        <p>经纬度: {{ currentLng }}, {{ currentLat }}</p>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleConfirm">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import lodash from "lodash";
let that;
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchText: "",
      map: null,
      marker: null,
      currentLng: null,
      currentLat: null,
      selectedAddress: "",
      key: "HVTBZ-HRTKG-CSCQJ-I76AU-YV2I2-F5FHY",
      sk: "sCQWpv4mquBYoys6o8uoKaktBA7CU9sk",
      isMapApiLoaded: false,
      kwData: [],
      highlightedIndex: -1,
    };
  },
  watch: {
    visible: {
      handler: function(n) {
        if (n) {
          this.initMapApi().then(() => {
            this.$nextTick(() => {
              this.initMap();
            });
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    that = this;
  },
  methods: {
    // 新增方法：确保地图API加载完成
    initMapApi() {
      return new Promise((resolve) => {
        if (window.TMap && window.TMap.Map) {
          this.isMapApiLoaded = true;
          resolve();
          return;
        }

        // 如果未加载，设置回调函数
        window.initMapCallback = () => {
          this.isMapApiLoaded = true;
          resolve();
        };

        // 检查是否已经添加过脚本
        // https://map.qq.com/api/gljs?v=1.exp&libraries=service&key=GR7BZ-BZ36S-5NUO7-6Y7MG-FILLT-LIBF6
        if (!document.getElementById("qqMapScript")) {
          const script = document.createElement("script");
          script.id = "qqMapScript";
          script.src = `https://map.qq.com/api/gljs?v=1.exp&libraries=service&key=HVTBZ-HRTKG-CSCQJ-I76AU-YV2I2-F5FHY`;
          document.head.appendChild(script);
        }
      });
    },
    // 初始化地图
    initMap() {
      // 确保TMap.maps可用
      if (!window.TMap || !window.TMap.Map) {
        console.error("腾讯地图API未正确加载");
        return;
      }

      if (this.map) return;

      // 创建地图实例
      this.map = new TMap.Map("map-container", {
        pitch: 45,
        zoom: 12,
        center: new TMap.LatLng(30.572961, 104.066301),
      });
      this.addMarker(new TMap.LatLng(30.572961, 104.066301));

      // 添加点击事件
      this.map.on("click", (evt) => {
        const latLng = evt.latLng;
        this.currentLng = latLng.getLng();
        this.currentLat = latLng.getLat();
        this.addMarker(latLng);
        this.getAddressByLatLng(this.currentLat, this.currentLng);
      });
    },
    // 添加标记
    addMarker(latLng) {
      if (this.marker) {
        this.marker.setMap(null);
      }

      this.marker = new TMap.MultiMarker({
        map: this.map,
        styles: {
          marker: new TMap.MarkerStyle({
            width: 25,
            height: 35,
            anchor: { x: 12.5, y: 35 },
          }),
        },
        geometries: [
          {
            id: "location",
            styleId: "marker",
            position: latLng,
          },
        ],
      });
    },
    // 逆地址解析
    getAddressByLatLng(lat, lng) {
      try {
        const latLng = new TMap.LatLng(lat, lng);
        const geocoder = new TMap.service.Geocoder();

        geocoder
          .getAddress({
            location: latLng,
          })
          .then((result) => {
            if (result.result) {
              this.selectedAddress = result.result.address;
              // 可以获取更多信息
              const {
                title, // 地点名称
                address, // 详细地址
                location, // 包含lat,lng
              } = result.result;

              this.currentLng = location.lng;
              this.currentLat = location.lat;
              this.selectedAddress = address;
            }
          });
      } catch (error) {
        console.error("逆地址解析错误:", error);
        this.$message.error("获取地址失败");
      }
    },
    getKwd(event) {
      let kw = event.target.value;
      this.$jsonp("https://apis.map.qq.com/ws/place/v1/suggestion", {
        key: this.key,
        output: "jsonp",
        keyword: kw,
        region: "全国",
      })
        .then((res) => {
          if (res.status === 0) {
            this.kwData = res.data;
          } else {
            this.kwData = [];
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    // 键盘上箭头
    handleKeyUp() {
      if (this.kwData.length === 0) return;
      this.highlightedIndex = Math.max(-1, this.highlightedIndex - 1);
      this.scrollToHighlighted();
    },

    // 键盘下箭头
    handleKeyDown() {
      if (this.kwData.length === 0) return;
      this.highlightedIndex = Math.min(
        this.kwData.length - 1,
        this.highlightedIndex + 1
      );
      this.scrollToHighlighted();
    },

    // 键盘回车
    handleKeyEnter() {
      if (
        this.highlightedIndex >= 0 &&
        this.highlightedIndex < this.kwData.length
      ) {
        this.clickLiHandler(this.kwData[this.highlightedIndex]);
      }
    },

    // 滚动到高亮项
    scrollToHighlighted() {
      this.$nextTick(() => {
        const list = this.$el.querySelector(
          ".el-autocomplete-suggestion__list"
        );
        if (list && list.children && this.highlightedIndex >= 0) {
          const item = list.children[this.highlightedIndex];
          if (item) {
            item.scrollIntoView({ block: "nearest" });
          }
        }
      });
    },
    searchHandler: lodash.debounce(function(event) {
      this.getKwd(event);
      this.highlightedIndex = -1; // 搜索时重置高亮索引
    }, 500),
    clickLiHandler(kwObj) {
      console.log(kwObj);
      this.searchText = kwObj.title;
      this.selectedAddress = kwObj.address;
      this.currentLng = kwObj.location.lng;
      this.currentLat = kwObj.location.lat;
      this.addMarker(new TMap.LatLng(this.currentLat, this.currentLng));
      this.map.setCenter(new TMap.LatLng(this.currentLat, this.currentLng));
      this.kwData = [];
      this.highlightedIndex = -1; // 选择后重置高亮索引
    },
    // 确认选择
    handleConfirm() {
      if (!this.currentLng || !this.currentLat) {
        this.$message.warning("请先选择地点");
        return;
      }

      this.$emit("confirm", {
        address: this.selectedAddress,
        lng: this.currentLng,
        lat: this.currentLat,
      });
      this.$emit("update:visible", false);
    },
    // 关闭弹窗
    handleClose() {
      this.searchText = "";
      this.selectedAddress = "";
      this.currentLng = null;
      this.currentLat = null;
      if (this.marker) {
        this.marker.setMap(null);
        this.marker = null;
      }
      this.$emit("update:visible", false);
    },
  },
  beforeDestroy() {
    if (this.map) {
      this.map.destroy();
    }
  },
};
</script>

<style lang="scss" scoped>
.map-container {
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 20px;
}

.map-search {
  position: relative;

  /* 自动完成下拉菜单样式 */
  ul {
    margin: 5px 0 0;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    background-color: #fff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
    width: 100%;
    max-height: 280px;
    overflow-y: auto;
    padding: 6px 0;
    z-index: 99999999999;
    position: absolute;
    top: 100%;
    left: 0;

    li {
      font-size: 14px;
      padding: 0 20px;
      margin: 0;
      line-height: 34px;
      cursor: pointer;
      color: #606266;
      list-style: none;
      text-align: left;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      &:hover {
        background-color: #f5f7fa;
      }

      &.highlighted {
        background-color: #f5f7fa;
      }
    }
  }

  /* 输入框容器 */
  .el-input-style {
    position: relative;
    font-size: 14px;
    display: inline-block;
    width: 100%;

    /* 输入框前缀图标 */
    .el-input__prefix {
      position: absolute;
      height: 100%;
      left: 5px;
      top: 0;
      text-align: center;
      color: #c0c4cc;
      transition: all 0.3s;
      pointer-events: none;

      i {
        height: 100%;
        display: flex;
        align-items: center;
      }
    }

    /* 带前缀图标的输入框 */
    &.el-input--prefix input {
      padding-left: 30px;
    }

    /* 输入框本身 */
    input {
      -webkit-appearance: none;
      background-color: #fff;
      background-image: none;
      border-radius: 4px;
      border: 1px solid #dcdfe6;
      box-sizing: border-box;
      color: #606266;
      display: inline-block;
      font-size: inherit;
      height: 40px;
      line-height: 1;
      outline: none;
      padding: 0 15px;
      transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      width: 100%;

      /* 输入框悬停状态 */
      &:hover {
        border-color: #c0c4cc;
      }

      /* 输入框聚焦状态 */
      &:focus {
        border-color: #409eff;
        outline: none;
      }

      /* 禁用状态 */
      &:disabled {
        background-color: #f5f7fa;
        border-color: #e4e7ed;
        color: #c0c4cc;
        cursor: not-allowed;
      }
    }

    /* 小尺寸 */
    &.input-small {
      font-size: 13px;

      input {
        height: 32px;
        line-height: 30px;
      }

      .el-input__prefix i {
        font-size: 13px;
      }
    }

    /* 大尺寸 */
    &.input-large {
      font-size: 16px;

      input {
        height: 48px;
        line-height: 46px;
      }

      .el-input__prefix i {
        font-size: 16px;
      }
    }
  }
}

.selected-info {
  margin-top: 10px;
  padding: 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
  font-size: 14px;
  color: #606266;
}
</style>
